import React, { useEffect, useState } from 'react'
import AsyncSelect from "react-select/async";
import { customSelectStyle } from 'utils/style'

const RfpLocation = ({ data: dataObj, handleDataChange }: any) => {
    const [location, setLocation] = useState(dataObj?.content)

    useEffect(() => {
        if (dataObj?.updatedTime) {
            setLocation(dataObj.content)
        }
    }, [dataObj?.updatedTime])

    const handleChange = (e: any) => {
        setLocation(e.target.value)
        handleDataChange({ key: 'location', value: e.target.value })
    }

    return (
        <>
            <div className="mb-6 gap-x-6 w-72">
                <p className='text-[#344054] text-sm font-interMedium pb-1.5 pl-1'>{dataObj?.title}</p>
                <div className="relative w-full">
                    <div className="border border-[#D0D5DD] rounded-lg px-4 py-2 bg-[#fff] flex items-center group hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
                        <input
                            onChange={handleChange}
                            className='w-full placeholder:text-base placeholder:text-[#D0D5DD] pr-4'
                            placeholder='Enter here'
                            type="text"
                            value={location}
                        />
                    </div>
                    {/* <AsyncSelect
                        // value={dropdownValue}
                        // onChange={handleChange}
                        // loadOptions={loadOptions} // Assign the loadOptions function for asynchronous data fetching
                        isSearchable={true}
                        placeholder=""
                        isMulti
                        className="multi-select-wrapper location location-icon placeholder:text-[#344054] placeholder:text-base text-base text-[#344054]"
                        classNamePrefix="select"
                        styles={customSelectStyle} // Pass custom select styles if needed
                        components={{
                            IndicatorSeparator: () => null,
                        }}
                        getOptionLabel={(option: any) => option.label}
                        getOptionValue={(option: any) => option.value}
                        pageSize={10}
                        defaultOptions={true}
                    /> */}
                </div>
            </div>

        </>
    )
}

export default RfpLocation